import { isWebView } from '.'

const JFS_CUSTOMER_ID_KEY = 'customerId'
const JFS_PHONE_NUMBER_KEY = 'jfsPhoneNumber'
const JFS_TOKEN_KEY = 'jfsToken'

const getJfsTokenFromUrl = () => {
  if (isWebView()) return null

  return new URLSearchParams(window.location.search).get('token')
}

const setJfsToken = (token: string) => {
  if (isWebView()) return
  sessionStorage.setItem(JFS_TOKEN_KEY, token)
}

const getJfsToken = () => {
  if (isWebView()) return null

  return getJfsTokenFromUrl() || sessionStorage.getItem(JFS_TOKEN_KEY)
}

const setJfsCustomerId = (customerId: string | number) => {
  if (isWebView()) return
  sessionStorage.setItem(JFS_CUSTOMER_ID_KEY, String(customerId))
}

const getJfsCustomerId = () => {
  if (isWebView()) return null
  return (
    sessionStorage.getItem(JFS_CUSTOMER_ID_KEY) ||
    new URLSearchParams(window?.location?.search)?.get('customerId')
  )
}

const setJfsCustomerPhoneNumber = (phoneNumber: string) => {
  if (isWebView()) return
  sessionStorage.setItem(JFS_PHONE_NUMBER_KEY, phoneNumber)
}

const getJfsCustomerPhoneNumber = () => {
  if (isWebView()) return null
  return (
    sessionStorage.getItem(JFS_PHONE_NUMBER_KEY) ||
    new URLSearchParams(window?.location?.search)?.get('phoneNumber')
  )
}

const removeQueryParams = (paramNames: string[]) => {
  if (isWebView()) return

  const url = new URL(window.location.href)
  paramNames.forEach((paramName) => url.searchParams.delete(paramName))

  const query = url.searchParams.toString()
  const nextUrl = `${url.pathname}${query ? `?${query}` : ''}${url.hash}`
  window.history.replaceState({}, '', nextUrl)
}

export {
  getJfsCustomerId,
  getJfsCustomerPhoneNumber,
  getJfsToken,
  getJfsTokenFromUrl,
  removeQueryParams,
  setJfsCustomerId,
  setJfsCustomerPhoneNumber,
  setJfsToken,
}
